<template>
  <div class="home-container">
    <h1>Welcome to Task Management App</h1>
    <div v-if="isLoggedIn" class="button-group">
      <button class="btn" @click="signOut">Sign Out</button>
      <button class="btn" @click="goToDashboard">Go to Dashboard</button>
    </div>
    <div v-else class="button-group">
      <button class="btn" @click="signIn">Sign In with Google</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      isLoggedIn: false,
    };
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      const token = localStorage.getItem("token");

      this.isLoggedIn = !!token;
    },
    signIn() {
      // `${process.env.VUE_APP_API_URL}/api/auth/google`
      const apiUrl = `${process.env.VUE_APP_API_URL}/api/auth/google`;
      window.location.href = apiUrl;
    },
    signOut() {
      localStorage.removeItem("token");
      this.isLoggedIn = false;
      this.$router.push("/");
    },
    goToDashboard() {
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
/* General container styling for mobile */
.home-container {
  padding: 16px;
  text-align: left; /* Ensures left alignment */
}

h1 {
  color: #333;
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

/* Button group for layout */
.button-group {
  display: flex;
  flex-direction: column;
  gap: 10px; /* Space between buttons */
}

/* Styling for buttons */
.btn {
  width: 180px;
  display: inline-block;
  padding: 10px 15px;
  background-color: black;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #0056b3;
}
</style>
